<template>
    <div class="relative group w-32 mx-auto">
        <img
            :src="displayImage"
            alt="Avatar"
            class="
                rounded-full
                w-full
                mx-auto
                border-2 border-solid border-[#049DBF]
                aspect-square
                object-cover
            "
        />
        <button
            type="button"
            class="
                absolute
                top-0
                left-0
                w-full
                h-full
                flex
                items-center
                justify-center
                bg-black bg-opacity-50
                rounded-full
                text-white
                transition-all
                opacity-0
                group-hover:opacity-100
                invisible
                group-hover:visible
                cursor-pointer
                backdrop-blur
            "
            @click="pickFile"
        >
            Upload Profile
        </button>
    </div>
    <div class="text-center my-4">
        <button
            type="button"
            class="bg-gray-200 text-gray-800 rounded py-2 px-4 text-sm"
            @click="pickFile"
        >
            Upload Profile
        </button>
    </div>
    <input
        :name="name"
        type="file"
        accept="image/jpeg,image/png"
        ref="fileRef"
        @change="handleFileChange"
        class="hidden"
    />
</template>

<script setup>
import { ref } from "vue";

const fileRef = ref(null);

const handleFileChange = (e) => {
    const files = fileRef.value.files;
    const file = files[0];
    if (file) {
        const reader = new FileReader();
        reader.onloadend = (e) => {
            displayImage.value = reader.result;
        };
        reader.readAsDataURL(file);
    }
};

const props = defineProps({
    avatar: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        default: "avatar",
    },
});

const displayImage = ref(props.avatar);

const pickFile = () => {
    fileRef.value.click();
};
</script>

<style scoped></style>
